const ContentReports = () => {}

export default ContentReports
